/**
 * PDP Steps Support — mobile accordion toggle
 */
class PdpStepsSupport {
  constructor(section) {
    this.section = section;
    this.mobileQuery = window.matchMedia('(max-width: 990px)');
    this.boundOnClick = this.onClick.bind(this);
    this.boundOnKeydown = this.onKeydown.bind(this);
  }

  init() {
    this.section.addEventListener('click', this.boundOnClick);
    this.section.addEventListener('keydown', this.boundOnKeydown);
  }

  destroy() {
    this.section.removeEventListener('click', this.boundOnClick);
    this.section.removeEventListener('keydown', this.boundOnKeydown);
  }

  toggleItem(title) {
    if (!this.mobileQuery.matches) return;
    const item = title.closest('.pdp-steps-support__item');
    if (!item) return;
    const isOpen = item.getAttribute('data-open') === 'true';
    item.setAttribute('data-open', isOpen ? 'false' : 'true');
    title.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
  }

  onClick(e) {
    if (e.target.matches('.pdp-steps-support__item-title')) {
      this.toggleItem(e.target);
    }
  }

  onKeydown(e) {
    if (
      (e.key === 'Enter' || e.key === ' ') &&
      this.mobileQuery.matches &&
      e.target.matches('.pdp-steps-support__item-title')
    ) {
      e.preventDefault();
      this.toggleItem(e.target);
    }
  }
}

(() => {
  const section = document.querySelector('.pdp-steps-support');
  if (!section) return;
  const instance = new PdpStepsSupport(section);
  instance.init();
})();

document.body.addEventListener('click', (event) => {
  if (!event.target.closest('.pdp-steps-support__item-text') &&
    event.target.closest('.pdp-steps-support__item') &&
    !event.target.classList.contains('pdp-steps-support__item-title')) {
    const supportItem = event.target.closest('.pdp-steps-support__item');
    supportItem.querySelector('.pdp-steps-support__item-title').click();
  }
})